import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

var avatar = createMultiStyleConfigHelpers(["container"]);
var AvatarMenu = avatar.defineMultiStyleConfig({
    baseStyle: {
        container: {
            bg: 'neutrals.300',
            borderRadius: '50px',
            color: 'neutrals.900',
            ".chakra-icon": {
                width: '16px',
                height: '16px',
                color: 'neutrals.600',
            },
        },
    },
    sizes: {
        xl: {
            container: {
                width: '44px',
                height: '44px',
                fontSize: '24px',
                fontWeight: '700',
            },
        },
        lg: {
            container: {
                width: '32px',
                height: '32px',
                fontSize: '20px',
                fontWeight: '700',
            },
        },
        md: {
            container: {
                width: '24px',
                height: '24px',
                fontSize: '16px',
                fontWeight: '100',
                ".chakra-icon": {
                    width: '12px',
                    height: '12px',
                },
            },
        },
        sm: {
            container: {
                width: '16px',
                height: '16px',
                fontSize: '10px',
                fontWeight: '100',
                ".chakra-icon": {
                    width: '8px',
                    height: '8px',
                },
            },
        },
    },
    defaultProps: {
        size: 'xl'
    }
});
var avatarTheme = AvatarMenu;

export { avatarTheme };
//# sourceMappingURL=avatar.js.map
